import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

export function SourceTypeBadge({ sourceType }: Readonly<{ sourceType: string | null | undefined }>) {
  const { t } = useTranslation("inbound")
  return (
    <Text span fz={14} c="gray.8">
      {sourceType ? t(`sourceType.${sourceType}`, { defaultValue: "-" }) : "-"}
    </Text>
  )
}
